import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useMemo, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { SearchableSelect, SearchableSelectProps } from 'record-it-components/input/SearchableSelect/SearchableSelect';
import { prepareProps } from 'record-it-components/utils/propUtils';
import styles from './ExportYearSelect.module.css';
export type ExportYearSelectProps = Omit<SearchableSelectProps<number>, 'label' | 'items' | 'getDisplayTextOfItem' | 'getKeyOfItem' | 'value' | 'onValueChanged' | 'className'> & {
  /**
   * Year selected by default.
   *
   * @default current year
   */
  year: number;
  /**
   * Called whenever the user selects a new year.
   */
  onYearSelected: (selectedYear: number) => void;
};
export const ExportYearSelect: FunctionComponent<ExportYearSelectProps> = React.memo(props => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const currentYear = t0;
  let t1;
  if ($[1] !== props) {
    t1 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let onYearSelected;
  let remainingProps;
  let t2;
  if ($[3] !== t1) {
    ({
      year: t2,
      onYearSelected,
      ...remainingProps
    } = t1);
    $[3] = t1;
    $[4] = onYearSelected;
    $[5] = remainingProps;
    $[6] = t2;
  } else {
    onYearSelected = $[4];
    remainingProps = $[5];
    t2 = $[6];
  }
  const year = t2 === undefined ? currentYear : t2;
  const {
    t
  } = useTranslation();
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getYears(2022, currentYear);
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const yearsToSelect = t3;
  const getDisplayTextOfYear = _temp;
  const getKeyOfYear = _temp2;
  let t4;
  if ($[8] !== onYearSelected) {
    t4 = selectedYear => {
      onYearSelected(selectedYear);
    };
    $[8] = onYearSelected;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleYearSelected = useEventCallback(t4);
  let t5;
  if ($[10] !== t) {
    t5 = t("components.workTime.ExportYearSelect.label");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== handleYearSelected || $[13] !== remainingProps || $[14] !== t5 || $[15] !== year) {
    t6 = <SearchableSelect {...remainingProps} label={t5} items={yearsToSelect} getDisplayTextOfItem={getDisplayTextOfYear} getKeyOfItem={getKeyOfYear} value={year} onValueChanged={handleYearSelected} className={styles.yearSelect} data-testid="ExportYearSelect" />;
    $[12] = handleYearSelected;
    $[13] = remainingProps;
    $[14] = t5;
    $[15] = year;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
});

/**
 * Returns an array of all years from `from` (inclusive) to `to` (inclusive).
 * @param from The first year in the array.
 * @param to The last year in the array.
 */
function getYears(from: number, to: number): Array<number> {
  const years: Array<number> = [];
  for (let i = from; i <= to; i++) {
    years.push(i);
  }
  return years;
}
function _temp(yearToSelect) {
  return yearToSelect.toString();
}
function _temp2(yearToSelect_0) {
  return yearToSelect_0.toString();
}